import { SVG } from 'Components';
import { MainType } from './Container';
import { ROUTES, SVG_TYPE } from 'Shared/enums';
import { getCategoryIconType } from 'Shared/utils/categoryGroups';
import { useNavigate } from 'react-router';
import { generatePath } from 'react-router-dom';

function DashboardHomePage(props: MainType) {
  const { authorizedUser } = props;
  const isAuthorizedUser = authorizedUser !== 'init' && !!authorizedUser;
  const isMobile = window.innerWidth < 1024;
  const navigate = useNavigate();

  const firstName = isAuthorizedUser && authorizedUser?.name.split(' ')[0];
  return (
    <>
      <header className="dashboard__header my-profile__header dashboard-homepage">
        <div className="dashboard__container">
          <div>
            <h1 className="my-profile__title">Cześć {firstName} 👋🏻</h1>
            <h2 className="my-profile__subtitle">Od czego dziś zaczynamy?</h2>
          </div>
          <div className="dashboard-homepage__category" onClick={() => navigate(ROUTES.SELECT_CATEGORY)}>
            <div className="dashboard-homepage__category-icon" aria-hidden="true">
              <SVG type={getCategoryIconType(authorizedUser?.drivingCategory?.name || '')} />
            </div>
            {authorizedUser?.drivingCategory?.name ? authorizedUser?.drivingCategory?.name : '?'}
          </div>
        </div>
        {isMobile && <div className="my-profile__header--radius"></div>}
      </header>

      <div className=" dashboard__content my-profile__content">
        <div className="dashboard__container learning-page--dashboard-container">
          <div className="dashboard-homepage__body">
            <section className="dashboard-homepage__stats-panel">
              <div className="dashboard-homepage__stats-grid">
                <article className="dashboard-homepage__stats-item">
                  <p className="dashboard-homepage__stats-label">Ilość wykonanych egzaminów</p>
                  <p className="dashboard-homepage__stats-value">5</p>
                  <span className="dashboard-homepage__stats-icon" aria-hidden="true">
                    📝
                  </span>
                </article>

                <article className="dashboard-homepage__stats-item">
                  <p className="dashboard-homepage__stats-label">Ilość zdanych egzaminów</p>
                  <p className="dashboard-homepage__stats-value">2</p>
                </article>
              </div>

              <div className="dashboard-homepage__stats-trophy" aria-hidden="true">
                🏆
              </div>
            </section>

            <button type="button" className="dashboard-homepage__cta" onClick={() => navigate(ROUTES.EXAM)}>
              Nowy egzamin
            </button>
            <section className="dashboard-homepage__tiles">
              <article
                className="dashboard-homepage__tile dashboard-homepage__tile--learning"
                onClick={() => navigate(generatePath(ROUTES.LEARNING, { submenu: 'departments' }))}>
                <div className="dashboard-homepage__tile-icon" aria-hidden="true">
                  <SVG type={SVG_TYPE.STUDY} />
                </div>
                <h3 className="dashboard-homepage__tile-title">Nauka</h3>
              </article>

              <article className="dashboard-homepage__tile dashboard-homepage__tile--exam" onClick={() => navigate(ROUTES.EXAM)}>
                <div className="dashboard-homepage__tile-icon" aria-hidden="true">
                  <SVG type={SVG_TYPE.EXAM} />
                </div>
                <h3 className="dashboard-homepage__tile-title">Egzamin</h3>
              </article>

              <article className="dashboard-homepage__tile dashboard-homepage__tile--gamification" onClick={() => navigate(ROUTES.GAMIFICATION)}>
                <div className="dashboard-homepage__tile-icon" aria-hidden="true">
                  <SVG type={SVG_TYPE.TROPHY} />
                </div>
                <h3 className="dashboard-homepage__tile-title">Grywalizacja</h3>
              </article>

              <article className="dashboard-homepage__tile dashboard-homepage__tile--assistant" onClick={() => navigate(ROUTES.EXAM)}>
                <div className="dashboard-homepage__tile-icon" aria-hidden="true">
                  <SVG type={SVG_TYPE.ROBOT} />
                </div>
                <h3 className="dashboard-homepage__tile-title">Instruktor AI</h3>
              </article>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardHomePage;
